<template>
  <div :class="componentClassName">
    <a-page-heading>利用明細</a-page-heading>
    <m-section variant="fullpage">
      <m-action-card class="t-price-history-list__card" title="ご利用料金一覧" icon="file">
        <div class="t-history-list__controls">
          <form class="t-history-list__search-form" @submit.prevent="handleSubmitSearchForm">
            <div class="t-history-list__search">
              <m-form-input label="対象サービス">
                <a-select-field id="serviceNameSelect" v-model="searchForm.type" :options="serviceNameOptions" />
                <a-select-field id="searchDateSelect" v-model="searchForm.targetDate" :options="searchDateOptions" />
              </m-form-input>
            </div>
            <div class="t-history-list__search-button">
              <a-button
                id="searchButton"
                variant="fill"
                color="primary"
                size="small"
                label="検索"
                icon="search"
                icon-color="white"
                :disabled="isProcessing"
                @click="handleSearchClick"
              />
            </div>
          </form>
        </div>
        <div v-if="radioFlag === 'ccc'" class="t-application-invite-user-form__field">
          <a-radio
            id="businessType1Radio"
            v-model="radioValue"
            name="businessType"
            value="1"
            label="全体(COTOHA Call Center)"
          />
          <a-radio
            id="businessType8Radio"
            v-model="radioValue"
            name="businessType"
            value="8"
            label="全体料金(COTOHA Call Center)"
          />
          <a-radio
            id="businessType2Radio"
            v-model="radioValue"
            name="businessType"
            value="2"
            label="最大席数(BiCaaS連携用)"
          />
          <a-radio
            id="businessType3Radio"
            v-model="radioValue"
            name="businessType"
            value="3"
            label="利用番号(BiCaaS連携用)"
          />
          <a-radio
            id="businessType4Radio"
            v-model="radioValue"
            name="businessType"
            value="4"
            label="着信(BiCaaS連携用)"
          />
          <a-radio
            id="businessType5Radio"
            v-model="radioValue"
            name="businessType"
            value="5"
            label="発信携帯宛(BiCaaS連携用)"
          />
          <a-radio
            id="businessType6Radio"
            v-model="radioValue"
            name="businessType"
            value="6"
            label="発信固定宛(BiCaaS連携用)"
          />
          <a-radio
            id="businessType7Radio"
            v-model="radioValue"
            name="businessType"
            value="7"
            label="内線(BiCaaS連携用)"
          />
        </div>
        <div v-if="radioFlag === 'voicedx'" class="t-application-invite-user-form__field">
          <a-radio
            id="businessType1Radio"
            v-model="radioValue"
            name="businessType"
            value="1"
            label="全体(COTOHA Voice DX Basic)"
          />
          <a-radio
            id="businessType8Radio"
            v-model="radioValue"
            name="businessType"
            value="8"
            label="全体料金(COTOHA Voice DX Basic)"
          />
          <a-radio
            id="businessType2Radio"
            v-model="radioValue"
            name="businessType"
            value="2"
            label="発信利用番号(BiCaaS連携用)"
          />
          <a-radio
            id="businessType3Radio"
            v-model="radioValue"
            name="businessType"
            value="3"
            label="着信利用番号(BiCaaS連携用)"
          />
          <a-radio
            id="businessType4Radio"
            v-model="radioValue"
            name="businessType"
            value="4"
            label="着信(BiCaaS連携用)"
          />
          <a-radio
            id="businessType5Radio"
            v-model="radioValue"
            name="businessType"
            value="6"
            label="着信携帯宛転送(BiCaaS連携用)"
          />
          <a-radio
            id="businessType6Radio"
            v-model="radioValue"
            name="businessType"
            value="7"
            label="着信固定宛転送(BiCaaS連携用)"
          />
          <a-radio
            id="businessType7Radio"
            v-model="radioValue"
            name="businessType"
            value="5"
            label="発信(BiCaaS連携用)"
          />
        </div>
        <div class="t-history-list__search-button">
          <a-button
            id="csvDownloadButton"
            variant="fill"
            color="primary"
            size="small"
            label="CSVダウンロード"
            icon="download"
            icon-color="white"
            :disabled="isProcessing"
            @click="handleDownloadClick"
          />
        </div>
        <div v-if="radioFlag === 'ccc'" class="t-price-history-list__data-table">
          <m-data-table ref="dataTable" :empty-text="emptyText" :fit="true" :data="dataList" :is-loading="isLoading">
            <a-data-table-column prop="company_id" label="<span>契約ID</span>" align="left">
              <template #default="scope">
                {{ scope.row.company_id }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="amount" label="<span>通話時間<br/>（着信）</span>" align="left">
              <template #default="scope">
                {{ scope.row.incoming_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_method" label="<span>通話時間<br/>（発信 / 携帯）</span>" align="left">
              <template #default="scope">
                {{ scope.row.mobile_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_status" label="<span>通話時間<br/>（発信 / 固定）</span>" align="left">
              <template #default="scope">
                {{ scope.row.fixed_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_status" label="<span>通話時間<br/>（内線）</span>" align="left">
              <template #default="scope">
                {{ scope.row.extension_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_id" label="<span>利用ID数</span>" align="left">
              <template #default="scope">
                {{ scope.row.id }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_status" label="<span>利用番号数</span>" align="left">
              <template #default="scope">
                {{ scope.row.usage_number }}
              </template>
            </a-data-table-column>
          </m-data-table>
        </div>
        <div v-if="radioFlag === 'voicedx'" class="t-price-history-list__data-table">
          <m-data-table ref="dataTable" :empty-text="emptyText" :fit="true" :data="dataList" :is-loading="isLoading">
            <a-data-table-column prop="company_id" label="<span>契約ID</span>" align="left">
              <template #default="scope">
                {{ scope.row.company_id }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="amount" label="<span>通話時間<br/>（着信）</span>" align="left">
              <template #default="scope">
                {{ scope.row.incoming_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="amount" label="<span>通話時間<br/>（着信 / 携帯転送）</span>" align="left">
              <template #default="scope">
                {{ scope.row.incoming_mobile_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="amount" label="<span>通話時間<br/>（着信 / 固定転送）</span>" align="left">
              <template #default="scope">
                {{ scope.row.incoming_fixed_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_method" label="<span>通話時間<br/>（発信）</span>" align="left">
              <template #default="scope">
                {{ scope.row.mobile_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_status" label="<span>利用番号数<br/>（発信用）</span>" align="left">
              <template #default="scope">
                {{ scope.row.fixed_duration }}
              </template>
            </a-data-table-column>
            <a-data-table-column prop="payment_status" label="<span>利用番号数<br/>（着信用）</span>" align="left">
              <template #default="scope">
                {{ scope.row.extension_duration }}
              </template>
            </a-data-table-column>
          </m-data-table>
        </div>
        <div v-if="showPagination && !isLoading" class="t-price-history-list__pagination">
          <a-pagination :length="pageCount" :current-index="page" @page:selected="handlePageSelect" />
        </div>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="priceHistoryListMgmt_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APagination from '@/components/atoms/pagination';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { debounce, cloneDeep } from 'lodash';
import { POINT } from '@/libs/constants';

export default {
  name: 't-price-history-list',
  components: {
    APagination,
    APageHeading,
    MSection,
    MActionCard,
    MDataTable,
    ADataTableColumn,
  },
  mixins: [customRequest, messageContent],
  props: {
    class: {
      type: String,
      default: '',
    },
    page: {
      type: Number,
      default: 0,
    },
    pageCount: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showPagination: {
      type: Boolean,
      default: false,
    },
    handlePageSelect: {
      type: Function,
      default: () => {},
    },
    handleItemSelect: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      emptyText: '',
      searchForm: {
        type: 'ccc',
        targetDate: '2021-04-01',
      },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      dataList: [],
      radioValue: '1',
      serviceNameOptions: [
        {
          label: 'COTOHA Call Center',
          value: 'ccc',
        },
        {
          label: 'COTOHA Voice DX Basic',
          value: 'voicedx',
        },
      ],
      serviceName: 'ccc',
      searchDateOptions: [],
      radioFlag: 'ccc',
      authInfo: this.$store.state.user.authInfo,
      POINT,
      isProcessing: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-price-history-list');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    searchForm: {
      handler(val) {
        this.search();
      },
      deep: true,
    },
  },
  async created() {
    if (this.companyID === POINT) {
      await this.getUsage();
    }
  },
  mounted() {
    if (this.companyID !== POINT || (this.companyID === POINT && this.authInfo === 'operator')) {
      this.$router.push({ path: '/permission-denied' });
    }
  },
  methods: {
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleSubmitSearchForm(e) {
      e.preventDefault();
    },
    search: debounce(function () {
      const payload = cloneDeep(this.searchForm);
    }, 150),
    getUsage() {
      this.searchDateOptions.splice(0, this.searchDateOptions.length);
      // ボタン非活性
      this.isProcessing = true;
      this.postRequest('/usagemgmt/initSearchDate', {})
        .then(e => {
          if (e.status === 'failed') {
            throw new Error('/usagemgmt/initSearchDate response was not ok.');
          }
          this.searchDateOptions = e.result;
          const initDate = e.initDate;
          this.searchForm.targetDate = initDate;
          this.emptyText = messageContent.notifySearching();
          this.postRequest('/usagemgmt/getusagemgmt', { targetDate: initDate })
            .then(f => {
              if (f.status === 'failed') {
                throw new Error('/usagemgmt/getusagemgmt response was not ok.');
              }
              f.result.forEach(row => {
                const list = {
                  company_id: row.companyId,
                  sum_duration: row.type0 + row.type1 + row.type2,
                  incoming_duration: row.type2,
                  mobile_duration: row.type0,
                  fixed_duration: row.type1,
                  extension_duration: row.type5,
                  id: row.type6,
                  usage_number: row.type7,
                  occur_date: row.occurdate,
                };
                this.dataList.push(list);
              });
              if (this.dataList.length === 0) {
                this.emptyText = messageContent.alertEmptyList();
              }
              // ボタン活性
              this.isProcessing = false;
            })
            .catch(err => {
              console.log(err);
              this.showErrorModal(messageContent.requireTry('検索'));
            });
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('初期化'));
        });
    },
    handleSearchClick() {
      // リスト初期化
      this.dataList.splice(0, this.dataList.length);
      const month_ago = this.searchForm.targetDate;

      this.radioFlag = this.searchForm.type;
      // ボタン非活性
      this.isProcessing = true;

      // バックエンド要求
      if (this.searchForm.type === 'ccc') {
        this.postRequest('/usagemgmt/getusagemgmt', { targetDate: month_ago })
          .then(e => {
            if (e.status === 'failed') {
              throw new Error('/usagemgmt/getusagemgmt response was not ok.');
            }
            this.emptyText = messageContent.notifySearching();
            e.result.forEach(row => {
              const list = {
                company_id: row.companyId,
                sum_duration: row.type0 + row.type1 + row.type2,
                incoming_duration: row.type2,
                mobile_duration: row.type0,
                fixed_duration: row.type1,
                extension_duration: row.type5,
                id: row.type6,
                usage_number: row.type7,
                occur_date: row.occurdate,
              };
              this.dataList.push(list);
            });
            if (this.dataList.length === 0) {
              this.emptyText = messageContent.alertEmptyList();
            }
            // ボタン活性
            this.isProcessing = false;
          })
          .catch(err => {
            console.log(err);
            this.showErrorModal(messageContent.requireTry('検索'));
          });
      } else if (this.searchForm.type === 'voicedx') {
        this.postRequest('/usagemgmt/getvoicedxusage', { targetDate: month_ago })
          .then(e => {
            if (e.status === 'failed') {
              throw new Error('/usagemgmt/getvoicedxusage response was not ok.');
            }
            this.emptyText = messageContent.notifySearching();
            e.result.forEach(row => {
              const list = {
                company_id: row.companyId,
                sum_duration: row.type3 + row.type4,
                incoming_duration: row.type4,
                incoming_mobile_duration: row.type10,
                incoming_fixed_duration: row.type11,
                mobile_duration: row.type3,
                fixed_duration: row.type8,
                extension_duration: row.type9,
                id: '',
                usage_number: '',
                occur_date: row.occurdate,
                sum_number: row.type8 + row.type9,
              };
              this.dataList.push(list);
            });
            if (this.dataList.length === 0) {
              this.emptyText = messageContent.alertEmptyList();
            }
            // ボタン活性
            this.isProcessing = false;
          })
          .catch(err => {
            console.log(err);
            this.showErrorModal(messageContent.requireTry('検索'));
          });
      }
    },
    handleDownloadClick() {
      // ボタン非活性
      this.isProcessing = true;
      this.postRequest('/usagemgmt/getprice', {
        type: this.searchForm.type,
        csvKind: this.radioValue,
        dataList: this.dataList,
        targetDate: this.searchForm.targetDate,
      })
        .then(e => {
          if (e.status === 'failed') {
            throw new Error('/usagemgmt/getprice response was not ok.');
          }
          const blob = new Blob([e.result], { type: 'text/csv' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = e.resultfile;
          link.click();
          // ボタン活性
          this.isProcessing = false;
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('CSVダウンロード'));
        });
    },
  },
};
</script>
